/**
 * Used by `itemized-invoice-types` and other marketing-related call sites.
 * redo/model/src/marketing.ts re-exports for back-compat.
 */
export enum MarketingChannel {
  EMAIL = "email",
  SMS = "sms",
}
